import Home from "@/pages/home/home.vue";
import Index from "@/pages/index/index.vue";
import Page404 from "@/pages/page404/index.vue";
import Detail from "@/pages/detail/index.vue";
import NewsList from "@/components/newsList.vue";
import VideoList from "@/components/videoList.vue";
import LmList from "@/components/lmList.vue";
import ZtList from "@/components/ztList.vue";
import Search from "@/pages/home/search.vue";
import unionOverview from "@/pages/home/unionOverview.vue";
import moreNews from "@/pages/home/moreNews.vue";
import staffArtsMore from "@/pages/home/staffArtsMore.vue";
import documentation from "@/pages/home/documentation.vue";
import specialColumn from "@/pages/home/specialColumn.vue";
import detailsList from "@/pages/index/detailsList.vue";

const routes = [
  {
    name: "index",
    path: "/",
    component: Home,
    children: [
      {
        name: "index",
        path: "index",
        component: Index,
        meta: {
          title: "甘肃省总工会",
        },
      },
      {
        name: "detailsList",
        path: "detailsList",
        component: detailsList,
        meta: {
          title: "详情",
        },
      },
      {
        name: "detail",
        path: "detail",
        component: Detail,
        meta: {
          title: "详情",
        },
      },
      {
        name: "search",
        path: "search",
        component: Search,
        meta: {
          title: "搜索",
        },
      },
    {
        name: "lmList",
        path: "lmList",
        component: LmList,
        meta: {
          title: "劳模工匠",
        },
      },
      {
        name: "newsList",
        path: "newsList",
        component: NewsList,
        meta: {
          title: "列表",
        },
      },
      {
        name: "ztList",
        path: "ztList",
        component: ZtList,
        meta: {
          title: "热门专题",
        },
      },
      {
        name: "videoList",
        path: "videoList",
        component: VideoList,
        meta: {
          title: "视频展播",
        },
      },
      {
        name: "unionOverview",
        path: "unionOverview",
        component: unionOverview,
        meta: {
          title: "工会概况",
        },
      },
      {
        name: "moreNews",
        path: "moreNews",
        component: moreNews,
        meta: {
          title: "新闻资讯",
        },
      },
      {
        name: "staffArtsMore",
        path: "staffArtsMore",
        component: staffArtsMore,
        meta: {
          title: "职工文艺",
        },
      },
      {
        name: "documentation",
        path: "documentation",
        component: documentation,
        meta: {
          title: "文件资料",
        },
      },
      {
        name: "specialColumn",
        path: "specialColumn",
        component: specialColumn,
        meta: {
          title: "专题专栏",
        },
      },
      {
        path: "/",
        name: "甘肃省总工会",
        redirect: "index",
        meta: {
          title: "甘肃省总工会",
        },
      },
    ],
    meta: {
      title: "甘肃省总工会",
    },
  },
  {
    path: "*",
    component: Page404, //404页面
  },
];

export default routes;
